import * as v from "valibot";

// request schema
export const RequestSchema = v.object({
  ClusterId: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema
// 扩容策略，必须值

export const ScaleUpPolicySchema = v.picklist([
  "SCALE_UP_POLICY_LEAST_Priority",
  "SCALE_UP_POLICY_LEAST_WASTE",
  "SCALE_UP_POLICY_MOST_PODS",
  "SCALE_UP_POLICY_RANDOM",
]);
export type ScaleUpPolicy = v.InferOutput<typeof ScaleUpPolicySchema>;

export const ScaleUpSchema = v.object({
  Enabled: v.boolean(),
  ScaleUpPolicy: v.nullish(ScaleUpPolicySchema),
});
export type ScaleUp = v.InferOutput<typeof ScaleUpSchema>;

export const ScaleDownSchema = v.object({
  DaemonsetEvictionForEmptyNodes: v.boolean(),
  DaemonsetEvictionForOccupiedNodes: v.boolean(),
  DelayAfterAdd: v.number(),
  DelayAfterFailure: v.number(),
  Enabled: v.boolean(),
  GpuUtilizationThreshold: v.number(),
  MaxEmptyBulkDelete: v.number(),
  MaxGracefulTerminationSec: v.number(),
  MinReplicaCount: v.number(),
  SkipNodesWithLocalStorage: v.boolean(),
  SkipNodesWithSystemPods: v.boolean(),
  UnneededTime: v.number(),
  UtilizationThreshold: v.number(),
});
export type ScaleDown = v.InferOutput<typeof ScaleDownSchema>;

export const DataSchema = v.object({
  AutoscalingOptionId: v.nullish(v.string()),
  ClusterId: v.string(),
  CreatedTime: v.nullish(v.string()),
  DeletedTime: v.nullish(v.string()),
  Marker: v.number(),
  MaxResults: v.number(),
  ScaleDown: ScaleDownSchema,
  ScaleUp: ScaleUpSchema,
  ScanInterval: v.number(),
  TotalCount: v.number(),
  UpdatedTime: v.nullish(v.string()),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
